import { API_XANO_BASE_URL } from "../../config/api_config";
import { Api_url } from "../../common/api_url";
import { axiosAuth, axiosNoAuth } from "../../config/axiosInstances";

export function getIndustryAndRoleOptionData(successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.GetJobIndustryAndRolesData);

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}


export function getQualificationDegreeAndBranch(successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.GetQualificationDegreeAndBranch);

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function uploadResumeFile(user_id, resume_file, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.post(API_XANO_BASE_URL + Api_url.UploadResumeFile, resume_file, {
                'content-type': 'multipart/form-data',
                params: {
                    user_id
                }
            });

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }

}

export function saveIndustryJobRole(user_id, job_industry, job_role, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.post(API_XANO_BASE_URL + Api_url.SaveStep1, {
                user_id,
                job_industry,
                job_role
            });

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function saveEducationExperience(user_id, user_education, user_work_experience, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.post(API_XANO_BASE_URL + Api_url.SaveStep2, {
                user_id,
                user_education,
                user_work_experience
            });

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function saveCertificatesProjectsAchievements(user_id, user_certificates, user_projects, user_achievements, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.post(API_XANO_BASE_URL + Api_url.SaveStep3, {
                user_id,
                user_certificates,
                user_projects,
                user_achievements
            });

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function saveDetailsAndCalculateScore(user_id, user_certificates, user_projects, user_achievements, user_education, user_work_experience, job_industry, job_role, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.post(API_XANO_BASE_URL + Api_url.SaveStep4, {
                user_id,
                user_certificates,
                user_projects,
                user_achievements,
                user_education,
                user_work_experience,
                job_industry,
                job_role
            });

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getEpsScoreData(user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.getEPSData, {
                user_id,
            });

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getCertificateSearchData(search_text, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.getEPSCertificateSearch, {
                params: {
                    search_text
                }
            });

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getBoostDetails(user_id, type, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.getBoostTypeData, {
                params: {
                    user_id,
                    type
                }
            });

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getEpsFormData(user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.getEPSData, {
                params: {
                    user_id,
                }
            });

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }

}

export function getRolesInCompany(successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.getRoleInCompany);

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }

}

export function saveChangesAfterDelete(user_id, user_certificates, user_projects, user_achievements, user_education, user_work_experience, job_industry, job_role, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.post(API_XANO_BASE_URL + Api_url.saveChangesAfterDelete, {
                user_id,
                user_certificates,
                user_projects,
                user_achievements,
                user_education,
                user_work_experience,
                job_industry,
                job_role
            });

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getJESProjection(user_id, mskill_slug,successCallback , errorCallback){
    return async function(dispatch){
        try{

           const response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.GetJESProjectionData , {
                params : {
                    user_id, 
                    mskill_slug
                }
            })

            successCallback && successCallback(response.data);
            
        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}

export function updateJesScore(user_id, score_value,successCallback , errorCallback){
    return async function(dispatch){
        try{

           const response = await axiosNoAuth.post(API_XANO_BASE_URL + Api_url.UpdateEpsScore , {
    
                    user_id, 
                    score_value
                
            })

            successCallback && successCallback(response.data);
            
        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}

export function markViewedJobScore(user_id, successCallback ,errorCallback){
    return async function(dispatch){
        try{
            const response = await axiosNoAuth.post(API_XANO_BASE_URL + Api_url.ViewedJobScore,{
                user_id
            })

            successCallback && successCallback(response.data);
        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}